import { Modal, Box, Typography, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { NoShowAppointmentSkippedCardIcon } from "../../components/icon-components/NoShowAppointmentSkippedCardIcon";
import styles from "./NoShowAppointmentCard.module.scss";
import CustomButton from "../../components/v2/custom-button/CustomButton";
import { CloseIcon } from "../../components/icon-components/CloseIcon";

interface NoShowAppointmentResponseCardProps {
  modalOpen: boolean;
  onCloseModal: () => void;
  patientNoShowMessage: string;
}

const NoShowAppointmentResponseCard: React.FC<
  NoShowAppointmentResponseCardProps
> = ({ modalOpen, onCloseModal, patientNoShowMessage }) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={modalOpen}
      onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
        onCloseModal();
      }}
    >
      <Box className={styles.modalContainer}>
        <Box className={styles.header}></Box>
        <Box className={styles.icon}>
          <NoShowAppointmentSkippedCardIcon />
          <IconButton
            onClick={onCloseModal}
            aria-label="Close"
            className={styles.closeButton}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Box className={styles.bodyThankYouCard}>
          <Box className={styles.titleWrapper}>
            <Typography
              variant="h4"
              className={styles.title}
            >
              {t("noShowAppointment.thankYouMessage")}
            </Typography>
            <Box
              mb={"2rem"}
              className={styles.htmlContent}
              fontSize={"14px"}
              dangerouslySetInnerHTML={{ __html: patientNoShowMessage }}
            ></Box>
          </Box>

          <Box className={styles.buttonGroup}>
            <CustomButton
              variant="contained"
              text={t("noShowAppointment.closeButton")}
              onClick={onCloseModal}
              sx={{ minWidth: "115px", borderRadius: "24px" }}
            />
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default NoShowAppointmentResponseCard;
